export class ServiceLocation {
  public id: string;
  public lat: any;
  public lng: any;
  public name: string;
  public address: string;
  public phone: string;
  public email: string;
  public city: string;
}
